var map = {
	"./Lable.svg": "c555",
	"./cry.svg": "945f",
	"./delete.svg": "0d45",
	"./left.svg": "2b80",
	"./money.svg": "cf44",
	"./right.svg": "37af",
	"./statistics.svg": "8ccb",
	"./write.svg": "9ed1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b422";